export const locale = {
    lang: "en",
    data: {
        Add: "Agregar",
        Cancel: "Cancelar",
        Update: "Actualizar",
        Delete: "Eliminar",
        Reset: "Resetear contraseña",
        Duplicate: "Duplicar",
        View: "Vista",
        Copy: "Copiar",
        PERSONA_FISICA: "Persona Física",
        PERSONA_JURIDICA: "Persona Jurídica",
        SIMPLIFICADA: "Simplificada",
        AMPLIADA: "Ampliada",
        SIMPLIFICADA_Y_AMPLIADA: "Ambas",
        NAV: {
            APPLICATIONS: "Utils",
            SAMPLE: {
                TITLE: "Sample",
            },
            DASHBOARD: {
                TITLE: "Resumen",
            },
            LOGIN: {
                TITLE: "Login",
            },
            USUARIOS: {
                TITLE: "Usuarios",
            },
            //NAV.CONFIGURACION.TITLE
            CONFIGURACION: {
                TITLE: "Configuración",
            },
            TABLAS: {
                TITLE: "Tablas",
            },
            GRUPOS: {
                TITLE: "Grupos",
            },
            REGLAS: {
                TITLE: "Reglas",
            },
            EMPRESAS: {
                TITLE: "Empresas",
            },
            KEYWORDS: {
                TITLE: "Keywords",
            },
            AUDITORIAS: {
                TITLE: "Auditorias",
            },
            EVALUACIONES: {
                TITLE: "Evaluaciones",
            },
            OBJETIVOS: {
                TITLE: "Objetivos",
            },
            DIMENSIONES_RIESGOS: {
                TITLE: "Dimensiones Riesgo",
            },
            ESTRUCTURAS_JERARQUICAS: {
                TITLE: "Estructuras Jerarquicas",
            },
            FACTORES_DE_PONDERACION: {
                TITLE: "Factores de ponderación",
            },
            ANALISIS_DE_BRECHAS: {
                TITLE: "Análisis de brechas",
            },
            INICIAR_ANALISIS_DE_BRECHAS: {
                TITLE: "Preiniciar Análisis de brechas",
            },
            MIS_ANALISIS_DE_BRECHAS: {
                TITLE: "Mis Análisis de brechas",
            },
            TODOS_LOS_ANALISIS_DE_BRECHAS: {
                TITLE: "Todos los Análisis de brechas",
            },
            DEBIDA_DILIGENCIA: {
                TITLE: "Debida diligencia",
            },
            INICIAR_DEBIDA_DILIGENCIA: {
                TITLE: "Preiniciar debida diligencia",
            },
            MIS_DEBIDAS_DILIGENCIAS: {
                TITLE: "Mis debidas diligencias",
            },
            SUJETO_OBLIGADO: {
                TITLE: "Sujetos Obligados y Operaciones",
            },
            TIPO_SUJETO_OBLIGADO: {
                TITLE: "Tipo de sujeto obligado",
            },
            TIPO_OPERACION: {
                TITLE: "Tipo de operación",
            },
            RIESGO_PAIS: {
                TITLE: "Riesgo país",
            },
            MONEDA: {
                TITLE: "Moneda",
            },
            PROFESION_SUJETO_OBLIGADO: {
                TITLE: "Profesión/Ocupación",
            },
            PONDERACION_DE_RIESGOS: {
                TITLE: "Ponderación de riesgos",
            },
            ORIGEN_DE_FONDOS: {
                TITLE: "Origen de fondos",
            },
            SECTOR_ACTIVIDAD_SUJETO_OBLIGADO: {
                TITLE: "Sectores de Actividad",
            },
            TIPO_DOCUMENTO_ACTIVIDAD_SUJETO_OBLIGADO: {
                TITLE: "Tipo de documento",
            },
            TODAS_LAS_DEBIDAS_DILIGENCIAS: {
                TITLE: "Todas las debidas diligencias",
            },
            REGLAS_BASE: {
                TITLE: "Reglas Base",
            },
            MARCOS_DE_REFERENCIA: {
                TITLE: "Marcos de referencia",
            },
            FORMULARIOS: {
                TITLE: "Formularios",
            },
            RIESGOS: {
                TITLE: "Riesgos",
            },
            CONTROLES: {
                TITLE: "Controles",
            },
            ESCENARIO: {
                TITLE: "Escenario",
            },
            TIPOEVALUACION: {
                TITLE: "Tipos de evaluación",
            },
            TABLADEEVALUACION: {
                TITLE: "Criterios medición de brechas",
            },
            TABLADEEVALUACIONDEBIDADILIGENCIA: {
                TITLE: "Tablas de evaluación",
            },
            TIPOUSUARIOS: {
                TITLE: "Tipos de usuario",
            },
            PREINICIAREVALUACION: {
                TITLE: "Preiniciar Evaluación",
            },
            MIS_EVALUACIONES: {
                TITLE: "Mis Evaluaciones",
            },
            TODAS_LAS_EVALUACIONES: {
                TITLE: "Todas las evaluaciones",
            },
            SEGUIMIENTO_DE_KRI: {
                TITLE: "Seguimiento de KRI",
            },
            MIS_KRI: {
                TITLE: "Mis KRI",
            },
            CONSOLIDACION: {
                TITLE: "Consolidación",
            },
            CONSOLIDAR: {
                TITLE: "Consolidar",
            },
            MIS_EVALUACIONES_CONSOLIDADAS: {
                TITLE: "Mis Evaluaciones consolidadas",
            },
            TODAS_LAS_EVALUACIONES_CONSOLIDADAS: {
                TITLE: "Todas las evaluaciones consolidadas",
            },
            LISTADOS: {
                TITLE: "Listados",
            },
            LISTADO_DETALLADO_DE_LA_EVALUACION: {
                TITLE: "Evaluación detallada",
            },
            LISTADO_DETALLADO_DE_LA_EVALUACION_CONSOLIDADA: {
                TITLE: "Listado detallado de la evaluación consolidada",
            },
            LISTADO_DE_CONTROLES_CRITICOS: {
                TITLE: "Controles clave",
            },
            LISTADO_DE_MEDIDAS_DE_CONTINGENCIA: {
                TITLE: "Medidas de contingencia",
            },
            LISTADO_DE_KRI: {
                TITLE: "KRIs",
            },
            LISTADO_DE_EVOLUCION_DE_KRI: {
                TITLE: "Listado de evolución de KRI",
            },
            LISTADO_DE_CONTROLES_SUGERIDOS: {
                TITLE: "Controles sugeridos",
            },
            LISTADO_DE_CUMPLIMIENTO: {
                TITLE: "Cumplimiento",
            },
            VER_PISTAS_DE_AUDITORIA: {
                TITLE: "Pistas de auditoría",
            },
            VISTAS: {
                TITLE: "Vistas",
            },
            EMPLEADOS: {
                TITLE: "Empleados",
            },
            CLIENTES: {
                TITLE: "Clientes",
            },
            GRAFICOS: {
                TITLE: "Graficos",
            },
            REPORTES: {
                TITLE: "Reportes",
            },
            ENTIDADES: {
                TITLE: "Entidades",
            },
            PERFIL: {
                TITLE: "Perfil",
            },
            TRANSACCIONES: {
                TITLE: "Transacciones",
            },
            TRANSFERENCIAS: {
                TITLE: "Transferencias",
            },
            SETTINGS: {
                TITLE: "Promos",
            },
            VER_MANUAL: {
                TITLE: "Manual de usuario",
            },
            OPERACIONES: {
                TITLE: "Operaciones",
            }
        },
    },
};
